import {
  BasicButton,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  Modal,
  PrimaryButton,
} from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

interface Props {
  onCancel: () => void;
  onClose: () => void;
}
export function CancelModal(props: Props) {
  const { onCancel, onClose } = props;
  const { t } = useTranslation();
  return (
    <Modal isOpen>
      <Dialog>
        {() => (
          <>
            <DialogHeader onClose={onClose} testID="emp-ver-cancel-modal">
              {t("Unsaved changes")}
            </DialogHeader>
            <DialogContent>
              {t(
                "Are you sure you want to discard changes? Any edits you made won't be saved."
              )}
            </DialogContent>
            <DialogFooter>
              <BasicButton onPress={onClose} size="medium">
                {t("Cancel")}
              </BasicButton>
              <PrimaryButton onPress={onCancel} size="medium">
                {t("Discard changes")}
              </PrimaryButton>
            </DialogFooter>
          </>
        )}
      </Dialog>
    </Modal>
  );
}
